import React from "react";
import "../../styles/Home.scss";

function Home() {
    return (
        <div className="home">
            <div className="home-content">
                <div className="home-content-text">
                    <p>Hi! I'm Charlie. I'm 20 years old studying English and Comp sci at UVM. I have plenty of experience prorgamming, and almost no experience talking about it. \nThat said, somehow this website and it's maintenance are by far the most challenging things I've ever had the privledge of working on. </p>
                </div>
            </div>
        </div>
    );
}

export default Home;